import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

export default class Other extends Element {
  setDefaultShapes () {
    if (this.elementTypeName === 'Zone') {
      this.shapes = [
        new Ren.Line({
          name: 'line',
          points: this.points,
          stroke: '#dddddd',
          strokeWidth: 3,
          lineCap: 'round',
          closed: true,
          tension: 0.1
        })
      ]
    } else if (this.elementTypeName === 'Track') {
      // default
      this.shapes = [
        new Ren.Line({
          name: 'line',
          points: this.points,
          stroke: Color.black,
          strokeWidth: 5,
          lineCap: 'round'
        })
      ]
    } else if (this.elementTypeName === 'Ocl') {
      // default
      this.shapes = [
        new Ren.Line({
          name: 'line',
          points: this.points,
          stroke: Color.black,
          strokeWidth: 5,
          lineCap: 'round'
        })
      ]
    } else if (this.elementTypeName === 'Feeder') {
      // default
      this.shapes = [
        new Ren.Line({
          name: 'line',
          points: this.points,
          stroke: Color.black,
          strokeWidth: 2,
          lineCap: 'round'
        })
      ]
    } else if (this.elementTypeName === 'Cat') {
      // default
      this.shapes = [
        new Ren.Line({
          name: 'line',
          points: this.points,
          stroke: 'blue',
          strokeWidth: 2,
          lineCap: 'round',
          closed: true
        })
      ]
    } else if (this.elementTypeName === 'Asset') {
      // default
      this.shapes = [
        new Ren.Line({
          name: 'line',
          points: this.points,
          stroke: '#dddddd',
          strokeWidth: 1,
          lineCap: 'round',
          closed: true,
          tension: 0.2
        })
      ]
    }
  }

  applyStatusOnShapes () {
    // no online/status for others at this moment
  }
}
